var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloonGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7af471;}.cls-3{fill:none;stroke:#ccc;stroke-miterlimit:10;}.cls-4{fill:#088425;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 23.8,
    r: 20.09
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.83,
    cy: 23.8,
    r: 20.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,.83a22.94,22.94,0,0,1,22.52,18A23.41,23.41,0,0,1,53.3,32.54,81.32,81.32,0,0,1,41,54.18,57.32,57.32,0,0,1,32.4,63a.53.53,0,0,1-.83,0,53.48,53.48,0,0,1-7.5-7.24A74.81,74.81,0,0,1,10.18,31.08,23,23,0,0,1,32,.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.91,19A22.45,22.45,0,0,0,32,1.22,22,22,0,0,0,21.25,4,22.7,22.7,0,0,0,10.75,31,74.24,74.24,0,0,0,24.27,55.38a52.65,52.65,0,0,0,7.31,7.24.51.51,0,0,0,.73.08l.08-.08a58.29,58.29,0,0,0,8.45-8.68A80.77,80.77,0,0,0,52.77,32.58,23.51,23.51,0,0,0,53.91,19Zm-22,23.58A18.81,18.81,0,1,1,50.65,23.72v.1A18.79,18.79,0,0,1,31.92,42.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.42,13.73c1.72,0,3.83-.11,5.93.06,2.31.18,4.12,1.59,4.13,3.19v7.39c0,.37-.15.47-.67.46H37.6c-.47,0-.6-.1-.59-.43V19c0-.56-.28-.84-.89-.91-.81-.11-1.35.22-1.35.82v5.4c0,.41-.18.51-.76.5H29.88c-.54,0-.69-.09-.68-.46V19c0-.55-.35-.86-1-.88s-1.2.24-1.2.8v5.38c0,.43-.15.57-.79.56H22.05c-.42,0-.64,0-.64-.39V17c0-1.83,2.21-3.24,5-3.26C28.37,13.72,30.18,13.73,32.42,13.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.78,33.11a7.57,7.57,0,0,1-6.35-7.47v-.45H21.88a.45.45,0,0,0-.45.44v0c.45,7.9,6,10.41,8.83,11.18a3.06,3.06,0,0,0,.51.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.11,25.19H39.55v.45a7.59,7.59,0,0,1-6.21,7.45v3.82l.35-.07c2.89-.77,8.38-3.28,8.83-11.18a.44.44,0,0,0-.4-.47Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonGreen);
export default __webpack_public_path__ + "static/media/balloon_green.0427d2d1cd4c844a61c7487e5834f7ee.svg";
export { ForwardRef as ReactComponent };